<script>
import router from '@/modules/router'
import FormValidation from '@/components/atoms/FormValidation'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import InputLine from '@/components/atoms/inputlib/components/InputLine'
import ModalLogout from '@/components/organism/modal/ModalLogout'

export default {
    name: 'ResetPassword',
    components: {
        ModalLogout,
        InputLine,
        ButtonLoader,
        FormValidation,
    },
    data() {
        return {
            loading: false,
            logoutLoading: false,
            emailRequestLoading: false,
            emailSent: false,
            email: null,
            info: false,
            plainPassword: null,
            psw: null,
            tokenError: null,
            invalid: null,
        }
    },

    methods: {
        logout() {
            if (this.$user.isLoggedIn) {
                this.logoutLoading = true
                this.$refs.ModalLogout.logout().finally(() => {
                    this.logoutLoading = false
                })
            }
        },
        resetPassword() {
            if (!this.$user.isLoggedIn) {
                this.tokenError = null
                this.loading = true
                this.$user
                    .resetPassword({
                        plain_password: this.plainPassword,
                        token: this.$route.query.token,
                    })
                    .then((res) => {
                        if (!res.email) this.$router.push({ name: 'login' })
                        this.$user
                            .login({
                                email: res.email,
                                password: this.plainPassword,
                            })
                            .then(() => {
                                this.$router.push({
                                    name: 'restaurant-list',
                                    params: { setLocation: true },
                                })
                            })
                            .catch(() => {
                                this.$router.push({ name: 'login' })
                            })
                            .finally(() => {
                                this.loading = false
                            })
                    })
                    .catch((error) => {
                        if (error.detail === 'token_not_found') this.tokenError = error.detail
                        if (error.detail === 'invalid_input_or_field_missing')
                            this.invalid = error.detail
                    })
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                this.$refs.ModalLogout.open()
            }
        },
        requestNewEmail() {
            if (!this.emailSent) {
                this.emailRequestLoading = true
                this.$user
                    .sendResetEmail(this.email)
                    .then((res) => {
                        if (res.code === 202) {
                            this.info = this.$t('login.new_psw_info.info_text', {
                                date: this.$options.filters.toDateTime(res.message),
                            })
                        }
                        this.emailSent = true
                    })
                    .finally(() => {
                        this.emailRequestLoading = false
                    })
            }
        },
        cancel() {
            this.$router.replace({ name: 'restaurant-list' })
        },
    },
    beforeRouteEnter(to, from, next) {
        if (!to.query.token) router.replace({ name: 'restaurant-list' })
        next((vm) => {
            if (vm.$user.isLoggedIn) vm.$refs.ModalLogout.open()
        })
    },
}
</script>

<template lang="pug">
.container-fluid.container-lg
    transition(name="slide-x" mode="out-in")
        .row(v-if="tokenError" key="requestNewEmail")
            .col-12.col-lg-4.offset-lg-4
                h1.mt-10.mb-5.text-center {{$t('login.forgot_psw')}}
                .alert.alert-danger.d-flex                        
                    icon.text-white.mr-4(
                        icon="fa-solid fa-info-circle"
                        size="lg")
                    | {{$t('login.invalid_token')}}            
                form-validation(@submit="requestNewEmail")
                    input-line(type="email" v-model="email" required) {{ $t("labels.email") }}
                    template(v-slot:submit)
                        button-loader.btn.btn-primary.btn-block.mt-5.mb-2(type="submit" :disabled="emailSent" :loading="emailRequestLoading" inline) {{$t('login.request_new_email')}}
                transition(name="fade")
                    .text-center.mt-2(v-if="emailSent" :class="{'text-danger': info}" v-html="info || $t('profile.new_psw_info')")
        .row(v-else key="resetPassword")
            .col-12.col-lg-4.offset-lg-4
                h1.mt-10.mb-5.text-center {{$t('login.set_your_new_psw')}}
                form-validation(@submit="resetPassword")
                    input-line(
                        type="password" 
                        v-model="plainPassword" 
                        :disabled="$user.isLoggedIn"  
                        autocomplete="new-password" 
                        validate='plain_password'
                        :min="8" 
                        :max="300"
                        :error="!!invalid"
                        same required live) {{$t('labels.psw')}}
                    input-line(
                        type="password" 
                        v-model="psw" 
                        :disabled="$user.isLoggedIn" 
                        :min="8" 
                        :max="300"
                        autocomplete="new-password" 
                        :same="$t('labels.error.psw')" 
                        required live) {{$t('labels.re_psw')}}
                    template(v-slot:submit)
                        button-loader.btn.btn-primary.btn-block.mt-5.mb-2(type="submit" :loading="loading" inline) {{$t('base.save')}}

    transition(name="fade")
        .row(v-if="$user.isLoggedIn")
            .col-12.col-lg-4.offset-lg-4
                button-loader.btn.btn-link.btn-block(@click="logout" :loading="logoutLoading" inline) {{$t('base.logout')}}
    modal-logout(ref="ModalLogout" :title="$t('login.want_to_logout')" :text="$t('login.already_logged_in_with', {email: $user.model.email})" @cancel="cancel")
</template>
